// extracted by mini-css-extract-plugin
export default {"transfer-button":"styles_transfer-button__Zv8KB"};